import { render, staticRenderFns } from "./ChatButton.vue?vue&type=template&id=66d551b5"
import script from "./ChatButton.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatButton.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports